// src/services/CountryService.js
import api from "./api";

export function getForexServices(page = 1, limit = 10, search = "") {
  return api.get(`/forexservice?page=${page}&limit=${limit}&search=${search}`);
}

export function getForexServiceById(id) {
  return api.get(`/forexservice/${id}`);
}

export function addForexService(data) {
  return api.post("/forexservice", data);
}

export function updateForexService(id, data) {
  return api.put(`/forexservice/${id}`, data);
}

export function deleteForexService(id) {
  return api.delete(`/forexservice/${id}`);
}
